<template>
  <app-chip
    v-if="definition"
    class="border-current/75 !rounded-full border backdrop-blur-sm"
    :icon="definition.icon"
    :size="size"
    :style="{ color: colors.text, backgroundColor: colors.background }"
  >
    {{ definition.label }}
  </app-chip>
</template>

<script lang="ts" setup>
const properties = defineProps<{
  event: Pick<DatabaseTable<"course_sessions">, "options">;
  size?: "small";
}>();

const definition = useEventType(properties.event.options.session_type);

const colors = computed(() => {
  return {
    text: hexToHSLA(definition.color, { saturation: 75, luminance: 35 }),
    background: hexToHSLA(definition.color, { luminance: 95 }),
  };
});
</script>
